import { AppState, ConsentLevel, useConsentGiven } from '@news-mono/web-common'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { StyledIframe } from '../../content/PuzzleIframe/PuzzleIframe.styled'
import { LoggerContext } from '../../diagnostics/LoggerContext'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface PuzzleIframeProps {
    link: string
    width?: number | string
    height?: number | string
    marginBottom?: keyof ThemeMargins
    innerRef?:
        | ((element: HTMLIFrameElement) => void)
        | React.RefObject<HTMLIFrameElement>
        | null
    sandbox?: string
    frameBorder?: number
    consentRequiredLevel?: ConsentLevel
}

export const PuzzleIframe: React.FC<PuzzleIframeProps> = ({
    link,
    marginBottom,
    innerRef,
    sandbox,
    width,
    height,
    frameBorder,
    consentRequiredLevel = 1,
}) => {
    const logger = React.useContext(LoggerContext)
    const [amuselabsHeight, setAmuseLabsHeight] = useState(height || 700)
    const consentGiven = useConsentGiven({
        consentRequiredLevel,
    })
    const authState = useSelector((state: AppState) => state.authentication)

    useEffect(() => {
        window.addEventListener('message', receiveMessage, false)

        function receiveMessage(event: any) {
            if (
                event.origin !== 'https://cdn2.amuselabs.com' ||
                typeof event.data !== 'string'
            )
                return

            const frameData: any = JSON.parse(event.data)
            if (frameData.frameHeight) {
                setAmuseLabsHeight(frameData.frameHeight)
            }
        }

        return () => window.removeEventListener('message', receiveMessage)
    }, [])

    if (!consentGiven) {
        return null
    }

    let puzzleSrc = link
    if (authState?.hashedUserEmail) {
        puzzleSrc += `&uid=${authState?.hashedUserEmail}`
    } else {
        authState &&
            logger.info(
                `Invalid hashedUserEmail: ${authState?.hashedUserEmail}`,
            )
    }

    return (
        <StyledIframe
            src={puzzleSrc}
            height={amuselabsHeight}
            width={width}
            marginBottom={marginBottom}
            ref={innerRef}
            sandbox={sandbox}
            frameBorder={frameBorder}
        >
            Sorry, we can't show this content as your browser does not support
            iframes.
        </StyledIframe>
    )
}
PuzzleIframe.displayName = 'PuzzleIframe'
